// extracted by mini-css-extract-plugin
export default {"ItemWrapper":"WorkoutSetUpItem_ItemWrapper__M5Ft0","HeaderWrapper":"WorkoutSetUpItem_HeaderWrapper__BiWOI"};